import { StyleSheet } from "@react-pdf/renderer";

export const BRAND = {
  name: "DIVE HRZN",
  tagline: "ADVENTURE BEYOND BOUNDARIES",

  logo: "https://res.cloudinary.com/dcan5dmpy/image/upload/dive_hrzn_logo_yya5qh.png",

  navy: "#082943",
  navyLight: "#123C59",
  cyan: "#65BBD2",
  yellow: "#FFC928",

  text: "#263445",
  muted: "#718096",
  border: "#DCE5ED",
  light: "#F2F6F9",

  green: "#238451",
  red: "#B54747",

  purple: "#6252A5",
  lightPurple: "#f6f4ff",
};

export const styles = StyleSheet.create({
  page: {
    paddingTop: 24,
    paddingBottom: 35,
    paddingHorizontal: 24,
    fontFamily: "NotoSans",
    fontSize: 9,
    color: BRAND.text,
    backgroundColor: "#FFFFFF",
  },

  // ------------------------------------------------
  // PREMIUM COVER
  // ------------------------------------------------

  hero: {
    height: 350,
    position: "relative",
    overflow: "hidden",
    backgroundColor: BRAND.navy,
    borderRadius: 12,
    marginBottom: 20,
  },

  heroImage: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },

  heroOverlay: {
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    backgroundColor: BRAND.navy,
    opacity: 0.78,
  },

  heroContent: {
    position: "absolute",
    left: 25,
    top: 22,
    width: "82%",
  },
  heroBrandRow: {
    flexDirection: "row",
    alignItems: "left",
    justifyContent: "left",
    gap: 10,
  },

  heroLogo: {
    width: 70,
    height: 70,
    objectFit: "contain",
    borderRadius: 8,
  },

  heroBrand: {
    fontSize: 15,
    fontWeight: "bold",
    letterSpacing: 3,
    color: "#FFFFFF",
    marginBottom: 4,
  },
  heroBrandDetails: {
    flexDirection: "column",
    justifyContent: "center",
  },
  heroTagline: {
    fontSize: 7,
    letterSpacing: 2,
    color: "#9BD9E9",
    marginBottom: 10,
    marginTop: 5,
    textAlign: "left",
  },

  heroTitle: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#FFFFFF",
    lineHeight: 1.25,
    marginBottom: 12,
  },

  heroLocation: {
    fontSize: 10,
    color: "#FFFFFF",
    marginBottom: 8,
  },

  heroSku: {
    fontSize: 8,
    color: "#B5D7E8",
    marginBottom: 17,
  },
  heroActions: {
    flexDirection: "row",
    alignItems: "right",
    gap: 10,
    marginTop: 5,
  },

  heroActionLink: {
    textDecoration: "none",
  },

  heroActionButton: {
    backgroundColor: BRAND.yellow,
    borderWidth: 1,
    borderColor: "#FFFFFF",
    paddingVertical: 10,
    paddingHorizontal: 10,
    borderRadius: 8,
  },

  heroActionText: {
    color: BRAND.navy,
    fontSize: 8,
    fontWeight: "bold",
    letterSpacing: 0.5,
    textDecoration: "none",
  },
  // PRICE BANNER

  heroPriceBox: {
    width: 215,
    height: 55,
    position: "relative",
    marginBottom: 17,
  },

  heroPriceShape: {
    position: "absolute",
    left: 0,
    top: 0,
    width: 215,
    height: 55,
  },

  heroPriceContent: {
    position: "absolute",
    left: 13,
    top: 11,
    flexDirection: "row",
    alignItems: "center",
  },

  heroPrice: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#101820",
  },

  heroPriceLabel: {
    fontSize: 9,
    color: "#101820",
  },

  // COVER BADGES

  heroStats: {
    flexDirection: "row",
    flexWrap: "nowrap",
    gap: 7,
    marginTop: 5,
  },

  heroStat: {
    flexDirection: "row",
    alignItems: "center",
    borderWidth: 1,
    borderColor: BRAND.cyan,
    borderRadius: 9,
    paddingVertical: 7,
    paddingHorizontal: 9,
    marginRight: 7,
    marginBottom: 6,
    minHeight: 32,
  },

  heroStatText: {
    color: "#FFFFFF",
    fontSize: 8,
  },

  // ICON CONTAINERS

  iconPeople: {
    width: 17,
    height: 17,
    marginRight: 7,
    position: "relative",
  },

  iconCalendar: {
    width: 16,
    height: 16,
    marginRight: 7,
    position: "relative",
  },

  iconStatus: {
    width: 16,
    height: 16,
    marginRight: 7,
    borderRadius: 10,
    backgroundColor: "#FFFFFF",
    alignItems: "center",
    justifyContent: "center",
  },

  // ------------------------------------------------
  // GENERAL SECTIONS
  // ------------------------------------------------

  section: {
    marginTop: 17,
    marginBottom: 5,
  },

  sectionTitle: {
    fontSize: 12,
    fontWeight: "bold",
    color: BRAND.navy,
    marginBottom: 9,
    paddingBottom: 6,
    borderBottomWidth: 1,
    borderBottomColor: BRAND.border,
    letterSpacing: 0.5,
  },

  paragraph: {
    fontSize: 9,
    lineHeight: 1.7,
    color: "#4B5968",
  },

  routeBox: {
    backgroundColor: BRAND.light,
    padding: 11,
    borderRadius: 5,
  },

  routeText: {
    fontSize: 10,
    fontWeight: "bold",
    color: BRAND.navy,
    lineHeight: 1.7,
  },

  // ------------------------------------------------
  // DAY CARDS
  // ------------------------------------------------

  dayCard: {
    marginBottom: 14,
    padding: 12,
    borderWidth: 1,
    borderColor: BRAND.border,
    borderRadius: 7,
    backgroundColor: "#FFFFFF",
  },

  dayNumber: {
    fontSize: 12,
    fontWeight: "bold",
    color: BRAND.cyan,
    marginBottom: 4,
    letterSpacing: 1,
  },

  dayHeading: {
    fontSize: 12,
    fontWeight: "bold",
    color: BRAND.navy,
    lineHeight: 1.4,
  },

  daySubtitle: {
    fontSize: 8,
    color: BRAND.muted,
    marginTop: 4,
    marginBottom: 9,
  },

  dayImage: {
    width: "100%",
    height: 160,
    objectFit: "contain",
    borderRadius: 10,
    marginTop: 5,
    marginBottom: 11,
  },

  detailRow: {
    flexDirection: "row",
    marginBottom: 6,
  },

  bullet: {
    width: 18,
    fontSize: 10,
    color: BRAND.cyan,
  },

  detailText: {
    flex: 1,
    fontSize: 10,
    lineHeight: 1.6,
    color: "#405064",
  },

  // ------------------------------------------------
  // MEALS
  // ------------------------------------------------

  mealRow: {
    flexDirection: "row",
    flexWrap: "wrap",
    marginTop: 9,
  },

  mealIncluded: {
    backgroundColor: "#E5F5EC",
    color: BRAND.green,
    paddingVertical: 5,
    paddingHorizontal: 7,
    borderRadius: 4,
    fontSize: 10,
    marginRight: 5,
    marginBottom: 4,
  },

  mealExcluded: {
    backgroundColor: "#F0F1F3",
    color: "#66717E",
    paddingVertical: 5,
    paddingHorizontal: 7,
    borderRadius: 4,
    fontSize: 10,
    marginRight: 5,
    marginBottom: 4,
  },

  overnight: {
    marginTop: 9,
    padding: 8,
    backgroundColor: BRAND.lightPurple,
    borderRadius: 4,
    fontSize: 10,
    color: BRAND.purple,
  },

  // ------------------------------------------------
  // TRANSFERS
  // ------------------------------------------------

  transferCard: {
    borderWidth: 1,
    borderColor: BRAND.border,
    borderRadius: 6,
    padding: 11,
    marginBottom: 9,
    backgroundColor: "#FFFFFF",
  },

  transferHeading: {
    fontSize: 9,
    fontWeight: "bold",
    color: BRAND.cyan,
    marginBottom: 6,
  },

  transferRoute: {
    fontSize: 11,
    fontWeight: "bold",
    color: BRAND.navy,
    marginBottom: 6,
  },

  transferInfo: {
    fontSize: 8,
    color: BRAND.muted,
    lineHeight: 1.6,
  },

  includedText: {
    color: BRAND.green,
    fontWeight: "bold",
  },

  excludedText: {
    color: BRAND.red,
    fontWeight: "bold",
  },

  // ------------------------------------------------
  // LISTS
  // ------------------------------------------------

  listItem: {
    flexDirection: "row",
    marginBottom: 6,
  },

  listBullet: {
    width: 20,
    color: BRAND.cyan,
    fontSize: 9,
  },

  listText: {
    flex: 1,
    fontSize: 8.5,
    lineHeight: 1.6,
    color: "#405064",
  },

  // ------------------------------------------------
  // PAYMENT
  // ------------------------------------------------

  paymentBox: {
    backgroundColor: BRAND.light,
    borderRadius: 6,
    padding: 11,
  },

  // ------------------------------------------------
  // GALLERY
  // ------------------------------------------------

  gallery: {
    flexDirection: "row",
    flexWrap: "wrap",
  },

  galleryImage: {
    width: "31%",
    height: 85,
    objectFit: "cover",
    borderRadius: 4,
    marginRight: 7,
    marginBottom: 7,
  },

  // ------------------------------------------------
  // WATERMARK
  // ------------------------------------------------

  watermark: {
    position: "absolute",
    top: 430,
    left: 80,
    fontSize: 43,
    color: "#ffffff",
    opacity: 0.13,
    fontWeight: "bold",
    transform: "rotate(-35deg)",
  },

  // ------------------------------------------------
  // FOOTER
  // ------------------------------------------------

  footer: {
    marginTop: 25,
    paddingTop: 10,
    borderTopWidth: 1,
    borderTopColor: BRAND.border,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  footerText: {
    fontSize: 7,
    color: "#8794A1",
  },
  contactLink: {
    color: "#16834A",
    fontSize: 10,
    textDecoration: "underline",
    marginBottom: 10,
  },
  promotionContainer: {
    flexDirection: "row",
    alignItems: "stretch",
    justifyContent: "space-around",
    backgroundColor: "#F2F6F9",
    borderRadius: 8,
    paddingVertical: 17,
    paddingHorizontal: 10,
    marginBottom: 15,
  },

  promotionItem: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 8,
  },

  promotionTitle: {
    fontSize: 11,
    fontWeight: "bold",
    color: BRAND.navy,
    textAlign: "center",
    marginBottom: 7,
  },

  promotionDescription: {
    fontSize: 9,
    color: "#405064",
    textAlign: "center",
    lineHeight: 1.5,
  },

  promotionDivider: {
    width: 1,
    backgroundColor: "#AABBC8",
    marginVertical: 3,
  },
    // STAY OPTIONS & ADD-ONS

  optionSection: {
    marginTop: 2,
    marginBottom: 2,
  },

  optionGrid: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 8,
  },

  optionCard: {
    width: "31.5%",
    minHeight: 25,
    padding: 8,
    borderWidth: 1,
    borderColor: BRAND.border,
    borderRadius: 6,
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
  },

  optionName: {
    fontSize: 8.5,
    fontWeight: "bold",
    color: BRAND.navy,
    marginBottom: 2,
    lineHeight: 1.3,
  },

  optionPrice: {
    fontSize: 8,
    color: BRAND.muted,
  },

  optionCategory: {
    fontSize: 9,
    fontWeight: "bold",
    color: BRAND.navy,
    marginTop: 2,
    marginBottom: 2,
  },
});
